export default __webpack_public_path__ + "static/media/icon-warning.bf0b1e9d.svg";